import React, { Component, useEffect, useState } from 'react';

import { SvgAmenities } from '../../common';
import i18next from 'i18next';

const AmenityItem = ({ icon, label }) => {
  return (
    <div className="amenity-item">
      <SvgAmenities name={icon} color="white" />
      <span>{label}</span>
    </div>
  );
};

const AmenitiesStrip = ({ t }) => {
  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  return (
    <div className="home-amenities-strip white-text">
      <img src="/images/home-amenities-row-bg.png" />
      <div className="orange-bg">
        <div className="content-container font11">
          <div className="bold-text" style={{ fontSize: '16pt', fontWeight: 800 }}>
            {t('HOME.WE_MAKE_YOUR_TRIP_A_MORE_COMFORTABLE_EXPERIENCE')}
          </div>
          <div
            style={{
              height: 3,
              background: '#f6ca3d',
              width: 50,
              marginTop: 9,
            }}
          ></div>

          <div className="aminity-row">
            <AmenityItem label={t('HOME.WI-FI')} icon="WIFI" /> |
            <AmenityItem label={t('HOME.AC_AND_HEATING')} icon="AIR_CONDTION" /> |
            <AmenityItem label={t('HOME.BATHROOMS')} icon="RESTROOMS" /> |
            <AmenityItem label={t('HOME.BAGGAGE')} icon="BAGGAGE" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmenitiesStrip;



// WEBPACK FOOTER //
// ./src/features/home/AmenitiesStrip/AmenitiesStrip.js